import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Asesores = () => {
  return (
    <div
      className="home-background"
      style={{ backgroundColor: "#1a1d38" }}
    >
      <Container className="h-100">
        <Row className="h-100 align-items-center">
          <Col md={12} className="hero-heading">
            <h1
              style={{ fontWeight: "bolder", fontSize: "clamp(2.2rem, 5vw, 4.5rem)", lineHeight: 1.1 }}
              className="text-white px-3 font-jura"
            >
              CONOCE A LOS ASESORES QUE TE AYUDAN A TRANSPORTAR TU VEHÍCULO{" "}
              <span className="text-green">SIN QUE MANEJES</span>
            </h1>
            <h5
              className="text-g200 px-3"
              style={{ fontWeight: "400", fontSize: "clamp(1.1rem, 1.6vw, 1.6rem)" }}
            >
              Asesores verificados, atención directa por WhatsApp.
            </h5>
          </Col>
        </Row>
      </Container>
      <div className=" vectores"></div>
    </div>
  );
};

export default Asesores;
